import { ComponentProps } from 'react'
import { FieldValues, FormProvider, SubmitHandler, UseFormReturn, useForm, UseFormProps } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

interface Props<T extends FieldValues> extends Omit<ComponentProps<'form'>, 'onSubmit'> {
    form: UseFormReturn<T>
    onSubmit: SubmitHandler<T>
}

export const Form = <T extends FieldValues>({ form, onSubmit, children, ...props }: Props<T>) => (
    <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} {...props}>
            {/* <fieldset> passes the form's 'disabled' state to all of its elements,
            allowing us to handle disabled style variants with just css */}
            <fieldset disabled={form.formState.isSubmitting}>{children}</fieldset>
        </form>
    </FormProvider>
)

interface UseZodFormProps<S extends z.ZodSchema> extends Exclude<UseFormProps<z.infer<S>>, 'resolver'> {
    schema: S
}

export const useZodForm = <S extends z.ZodSchema>({ schema, ...formProps }: UseZodFormProps<S>) =>
    useForm({
        ...formProps,
        resolver: zodResolver(schema),
    })
